export const CASES = [
    {
        key: "transport",
        title: "un transporteur",
        tags: ["Transport routier", "~8 M€ de CA", "Centre-Val de Loire"],
        savings: "40 000 €",
        days: 26,
        constat:
            "Deux banques, un découvert mobilisé sur les pointes basses de trésorerie (BFR), et un contrat d'affacturage couvrant 25 % du chiffre d'affaires. Total : 71 K€ de frais bancaires par an, soit 0,89 % du CA, un niveau élevé pour le secteur, sans visibilité claire sur le détail des lignes facturées.",
        steps: [
            "Audit des frais bancaires, ligne par ligne",
            "Analyse des contrats d'affacturage et de découvert",
            "Rendez-vous avec les banquiers de l'entreprise",
            "Négociation des conditions avec les banques et le factor",
        ],
        resultat:
            "Frais ramenés à 31 K€ après renégociation, soit 40 K€ d'économies récurrentes chaque année. Le ratio frais / CA passe de 0,89 % à 0,39 %.",
        before: 71,
        after: 31,
        pct: 56,
        ratioBefore: "0,89 %",
        ratioAfter: "0,39 %",
    },
    {
        key: "defense",
        title: "un exportateur",
        tags: ["Défense & aéronautique", "~30 M€ de CA", "Occitanie"],
        savings: "102 000 €",
        days: 24,
        constat:
            "Quatre banques, un découvert mobilisé sur les pointes basses de trésorerie (BFR), et 75 % du chiffre d'affaires réalisé à l'international, adossé à des crédits documentaires. Total : 180 K€ de frais bancaires par an, soit 0,60 % du CA, avec des commissions de crédoc et de change dispersées sur quatre établissements, sans mise en concurrence.",
        steps: [
            "Audit des frais bancaires, ligne par ligne",
            "Analyse des crédits documentaires, opérations de change et découvert",
            "Rendez-vous avec les banquiers des quatre établissements",
            "Négociation et mise en concurrence des conditions",
        ],
        resultat:
            "Frais ramenés à 78 K€, soit 102 K€ d'économies récurrentes chaque année. Le ratio frais / CA passe de 0,60 % à 0,26 %.",
        before: 180,
        after: 78,
        pct: 57,
        ratioBefore: "0,60 %",
        ratioAfter: "0,26 %",
    },
    {
        key: "franchise",
        title: "un réseau multi-sites",
        tags: ["Franchise food & fitness", "~40 M€ de CA", "France & international"],
        savings: "73 000 €",
        days: 45,
        constat:
            "Un réseau de franchises multi-sites où 80 % du chiffre d'affaires est encaissé par carte (monétique / TPE), plus 15 % de virements internationaux, le tout réparti sur sept banques. Total : 220 K€ de frais bancaires par an, soit 0,55 % du CA, avec des commissions monétiques jamais renégociées et éclatées entre sept partenaires.",
        steps: [
            "Audit des contrats monétiques et des frais bancaires, ligne par ligne",
            "Analyse des commissions d'encaissement CB sur l'ensemble des points de vente",
            "Mise en concurrence et rendez-vous avec les sept banques",
            "Négociation des conditions (monétique, flux, international)",
        ],
        resultat:
            "Frais ramenés à 147 K€, soit un tiers d'économies : 73 K€ par an, récurrents. Le ratio frais / CA passe de 0,55 % à 0,37 %.",
        before: 220,
        after: 147,
        pct: 33,
        ratioBefore: "0,55 %",
        ratioAfter: "0,37 %",
    },
];
